import { render } from "./guidance.vue?vue&type=template&id=24f0246e&scoped=true"
import script from "./guidance.vue?vue&type=script&lang=js"
export * from "./guidance.vue?vue&type=script&lang=js"

import "./guidance.vue?vue&type=style&index=0&id=24f0246e&lang=scss&scoped=true"

import exportComponent from "D:\\cm_zhitu\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f0246e"]])

export default __exports__